<template>
  <b-container fluid>
    <b-row>
      <b-col md="auto">
        <h4>Contingents</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="auto">
        <b-form-group label="Daily:"
                      label-for="dailyContingent">
          <input type="number"
                 v-model="formObject.daily"
                 placeholder="∞"/>
        </b-form-group>
      </b-col>

      <b-col md="auto">
        <b-form-group label="Weekly:"
                      label-for="weeklyContingent">
          <input type="number"
                 v-model="formObject.weekly"
                 placeholder="∞"/>
        </b-form-group>
      </b-col>

      <b-col md="auto">
        <b-form-group label="Monthly:"
                      label-for="monthlyContingent">
          <input type="number"
                 v-model="formObject.monthly"
                 placeholder="∞"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="showRemains">
      <b-col md="auto">
        <b-collapse id="collapse-daily-remain" :visible="contingentRemainsDisplay.daily">
          <b-form-group label="Daily remain:">
            <b-input-group>
              <input type="number" v-model.number="formObject.dailyRemain" readonly disabled />
              <b-input-group-append>
                <b-btn @click="switchRemainDiffToDisplay('daily')"
                       variant="secondary"
                       size="sm">
                       <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-collapse>

        <b-collapse id="collapse-daily-remain-diff" :visible="!contingentRemainsDisplay.daily">
          <b-form-group label="Daily remain diff:">
            <b-input-group>
              <input type="number"
                     v-model.number="dailyRemainDiff"
                     v-on:blur="switchRemainDiffToDisplay('daily')"/>
              <b-input-group-append>
                <b-btn @click="switchRemainDiffToDisplay('daily')"
                       variant="secondary"
                       size="sm">
                       <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-collapse>
      </b-col>

      <b-col md="auto">
        <b-collapse id="collapse-weekly-remain" :visible="contingentRemainsDisplay.weekly">
          <b-form-group label="Weekly remain:">
            <b-input-group>
              <input type="number" v-model.number="formObject.weeklyRemain" readonly disabled />
              <b-input-group-append>
                <b-btn @click="switchRemainDiffToDisplay('weekly')"
                       variant="secondary"
                       size="sm">
                       <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-collapse>

        <b-collapse id="collapse-weekly-remain-diff" :visible="!contingentRemainsDisplay.weekly">
          <b-form-group label="Weekly remain diff:">
            <b-input-group>
              <input type="number"
                     v-model.number="weeklyRemainDiff"
                     v-on:blur="switchRemainDiffToDisplay('weekly')" />
              <b-input-group-append>
                <b-btn @click="switchRemainDiffToDisplay('weekly')"
                       variant="secondary"
                       size="sm">
                       <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-collapse>
      </b-col>

      <b-col md="auto">
        <b-collapse id="collapse-monthly-remain" :visible="contingentRemainsDisplay.monthly">
          <b-form-group label="Monthly remain:">
            <b-input-group>
              <input type="number" v-model.number="formObject.monthlyRemain" readonly disabled />
              <b-input-group-append>
                <b-btn @click="switchRemainDiffToDisplay('monthly')"
                       variant="secondary"
                       size="sm">
                       <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-collapse>

        <b-collapse id="collapse-monthly-remain-diff" :visible="!contingentRemainsDisplay.monthly">
          <b-form-group label="Monthly remain diff:">
            <b-input-group>
              <input type="number"
                     v-model.number="monthlyRemainDiff"
                     v-on:blur="switchRemainDiffToDisplay('monthly')" />
              <b-input-group-append>
                <b-btn @click="switchRemainDiffToDisplay('monthly')"
                       variant="secondary"
                       size="sm">
                       <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-collapse>
      </b-col>

      <b-col md="auto">
        <b-collapse id="collapse-unique-remain" :visible="contingentRemainsDisplay.unique">
          <b-form-group label="Unique remain:">
            <b-input-group>
              <input type="number" v-model.number="formObject.uniqueRemain" readonly disabled />
              <b-input-group-append>
                <b-btn @click="switchRemainDiffToDisplay('unique')"
                       variant="secondary"
                       size="sm">
                       <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-collapse>

        <b-collapse id="collapse-unique-remain-diff" :visible="!contingentRemainsDisplay.unique">
          <b-form-group label="Unique remain diff:">
            <b-input-group>
              <input type="number"
                     v-model.number="uniqueRemainDiff"
                     v-on:blur="switchRemainDiffToDisplay('unique')"/>
              <b-input-group-append>
                <b-btn @click="removeUniqueRemain"
                       variant="danger"
                       size="sm"
                       title="Remove unique remain">
                       <font-awesome-icon icon="trash"></font-awesome-icon>
                </b-btn>
                <b-btn @click="switchRemainDiffToDisplay('unique')"
                       variant="secondary"
                       size="sm">
                       <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-collapse>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'ContingentForm',
  props: {
    formObject: Object,
    showRemains: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      contingentRemainsDisplay: {
        daily: true,
        weekly: true,
        monthly: true,
        unique: true
      }
    }
  },
  methods: {
    switchRemainDiffToDisplay (kind) {
      this.contingentRemainsDisplay[kind] = !this.contingentRemainsDisplay[kind]
    },
    removeUniqueRemain () {
      this.formObject.uniqueRemainDiff = 'INFINITY'
      this.formObject.uniqueRemain = null
      this.switchRemainDiffToDisplay('unique')
    }
  },
  computed: {
    dailyRemainDiff: {
      get () {
        return this.formObject.dailyRemainDiff
      },
      set (diffAmount) {
        this.formObject.dailyRemain = this.formObject.dailyRemain -
                                      this.formObject.dailyRemainDiff +
                                      diffAmount
        this.formObject.dailyRemainDiff = diffAmount
      }
    },
    weeklyRemainDiff: {
      get () {
        return this.formObject.weeklyRemainDiff
      },
      set (diffAmount) {
        this.formObject.weeklyRemain = this.formObject.weeklyRemain -
                                      this.formObject.weeklyRemainDiff +
                                      diffAmount
        this.formObject.weeklyRemainDiff = diffAmount
      }
    },
    monthlyRemainDiff: {
      get () {
        return this.formObject.monthlyRemainDiff
      },
      set (diffAmount) {
        this.formObject.monthlyRemain = this.formObject.monthlyRemain -
                                      this.formObject.monthlyRemainDiff +
                                      diffAmount
        this.formObject.monthlyRemainDiff = diffAmount
      }
    },
    uniqueRemainDiff: {
      get () {
        return this.formObject.uniqueRemainDiff
      },
      set (diffAmount) {
        this.formObject.uniqueRemain = this.formObject.uniqueRemain -
                                      this.formObject.uniqueRemainDiff +
                                      diffAmount
        this.formObject.uniqueRemainDiff = diffAmount
      }
    }
  }
}
</script>

<style scoped>
</style>
